// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JakdT","buttons":"styles_buttons__3KGg7"};